import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '../../../../BaseComponents/Image'

type TeamFormCompetitionProps = {
    imageUrl?: string
    alt?: string
}

const TeamFormCompetition: FunctionComponent<TeamFormCompetitionProps> = ({ imageUrl, alt }) => (
    <Grid width={24} height={24} noExpand backgroundColor="moon-3" borderRadius={12} center>
        <Image imageUrl={imageUrl} alt={alt} width={14} aspectRatio="1:1" size="S" />
    </Grid>
)
export default TeamFormCompetition
